import React, {Component} from 'react';
import {
  RefinementListFilter,
  ResetFilters,
  SideBar,
  SearchkitComponent,
  SortingSelector,
  Select,
  MenuFilter,
  NumericRefinementListFilter
} from 'searchkit';
import ToggleSwitch from './ToggleSwitch';
import { SearchLabel } from './styles/SearchLabel';
import { H3 } from './styles/H3';
import { ToggleBox } from './styles/ToggleBox';
import { ToggleLabel } from './styles/ToggleLabel';
import { ToggleCheckbox } from './styles/ToggleCheckbox';
import classNames from 'classnames';

class Filters extends Component {
  constructor(props) {
    super();
    this.state = {
      ratingVisible: false
    }
  }

  toggleRating() {
    this.setState({
      ratingVisible: !this.state.ratingVisible
    })
    if (this.state.ratingVisible) {
      $('.sk-item-list__item.is-active').each(function(){
        $(this).click();
      });
    }
    else {
      document.querySelector('.sk-item-list__item').click();
    }
  }

  render() {
    const ifProduct = this.props.searchEndpoint == "/products",
          ifMosque = this.props.searchEndpoint == "/mosques";

    const ratingVisible = this.state.ratingVisible;
    const handleToggleSwitch = classNames({
      'toggle-switch': true,
      'active-toggle-switch': ratingVisible
    })

    const toggleRating = classNames({
      'rating-hidden': true,
      'rating-visible': ratingVisible
    })

    return (
      <div id="filters">
        <div className="sidebar-top">
          <H3>Filters</H3>
          <SearchLabel>Sort by</SearchLabel>
          { !ifMosque &&
            <div className="sidebar-sort">
              <SortingSelector
                options={[
                {label: 'Relevance', field: '_score', order: 'desc'},
                {label: 'Name', field: 'name', order: 'asc'},
                {label: 'Rating', field: 'rating', order: 'desc'},
                {label: 'Number of reviews', field: 'reviews_count', order: 'desc'}
              ]} />
            </div>
          }
          { ifMosque &&
            <div className="sidebar-sort">
              <SortingSelector
                options={[
                {label: 'Relevance', field: '_score', order: 'desc'},
                {label: 'Name', field: 'name', order: 'asc'}
              ]} />
            </div>
          }
          <div className="sidebar-filter-category">
            { ifProduct && !ifMosque && <SearchLabel>Category</SearchLabel> }
            <MenuFilter
              id='category'
              field='category'
              listComponent={Select} />
          </div>
          <div className="sidebar-filter-store">
            { ifProduct && !ifMosque && <SearchLabel>Store</SearchLabel> }
            <MenuFilter
              id='store'
              field='store'
              listComponent={Select} />
          </div>
          { !ifMosque &&
            <div className="rating-filter">
              <ToggleBox>
                <ToggleLabel>Rating</ToggleLabel>
                <ToggleCheckbox>
                  <input type="checkbox" />
                  <span className={handleToggleSwitch} onClick={() => this.toggleRating()}></span>
                </ToggleCheckbox>
              </ToggleBox>
              <div className={toggleRating}>
                <NumericRefinementListFilter
                  id='positive_ratings_count'
                  title=''
                  field='positive_ratings_count'
                  multiselect={true}
                  options={[
                    {title:'1', from:1},
                    {title:'50', from:50},
                    {title:'100', from:100}
                  ]}
                />
              </div>
            </div>
          }
        </div>
        <RefinementListFilter
          title=''
          id='filters'
          field='filters'
          operator="AND"
          orderKey='_term'
          itemComponent={ToggleSwitch}
        />
      </div>
    );
  }
}

export default Filters;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/Filters.jsx